'use client';
import { classNames } from '@repo/ui/src/utils/classNames';
import useEmblaCarousel from 'embla-carousel-react';
import Section from '@repo/ui/src/components/Section';
import { appConfig } from '../../utils/appConfig';
import Quote from './_Quote';
import { LeftArrow, RightArrow } from '@repo/ui/src/components/Carousels/CarouselArrows';
import { QuoteProps } from './_Quote';

interface Props {
  quotes: Array<QuoteProps>;
}

const QuoteCarousel = ({ quotes }: Props) => {
  const isInfinite = quotes?.length > 1;
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: isInfinite, watchDrag: false });

  if (!quotes) return null;

  return (
    <Section
      role="region"
      ariaLabel="quote carousel"
      dark
      butcherPaper={!appConfig.isMeater}
      texture={appConfig.isMeater}
      gutterX
      gutterY
      zIndexNone
      className={classNames(
        'dark-mode quote-carousel flex justify-center overflow-hidden',
        quotes?.length > 1 && 'has-arrows',
      )}
    >
      <div className={classNames('flex flex-row justify-center items-center max-w-footer')}>
        {quotes?.length > 1 && (
          <button
            aria-label="View previous quote"
            className="h-fit border-0 bg-transparent"
            onClick={() => emblaApi?.scrollPrev()}
          >
            <LeftArrow aria-label={null} asSpan={true} darkMode />
          </button>
        )}
        <div ref={emblaRef} className="max-w-screen-lg w-full overflow-hidden">
          <div className="flex">
            {quotes?.map((quote) => (
              <div key={quote.text} className="flex-[0_0_100%]">
                <Quote {...quote} />
              </div>
            ))}
          </div>
        </div>
        {quotes?.length > 1 && (
          <button
            aria-label="View next quote"
            className="h-fit border-0 bg-transparent"
            onClick={() => emblaApi?.scrollNext()}
          >
            <RightArrow aria-label={null} asSpan={true} darkMode />
          </button>
        )}
      </div>
    </Section>
  );
};

export default QuoteCarousel;
